/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Team_Manager_Member_Added_SuccessInputs */



/**
* | output |
* | --- |
* | "{email} was added to the team" |
*
* @param {Team_Manager_Member_Added_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_member_added_success = /** @type {((inputs: Team_Manager_Member_Added_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Member_Added_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.email} a été ajouté à l'équipe`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.email} wurde zum Team hinzugefügt`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.email} è stato aggiunto al team`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.email} добавлен в команду`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.email} se añadió al equipo`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`已将 ${i?.email} 添加到团队`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.email} をチームに追加しました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.email} को टीम में जोड़ा गया`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.email} foi adicionado à equipa`)
	return /** @type {LocalizedString} */ (`${i?.email} was added to the team`)
});